import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import firebase from "firebase/app";
import "firebase/auth";
import { db } from "../firebase/firebase";

Vue.use(Vuex);

const usersRef = db.collection("users");

const store = new Vuex.Store({
  state: {
    user: "",
    userId: "",
    userEmail: "",
    userName: "",
    error: "",
    status: "",
    booked: false,
    loading: null,
    userIsCheckedIn: false,
    userIsAdmin: false,
    emailSentToCustomer: false,
    emailSentToAdmin: false,
    bookingDetails: {},
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload.uid;
      usersRef.doc(payload.uid).set(
        {
          email: payload.email,
        },
        { merge: true }
      );
    },
    setAdmin(state, payload) {
      state.userIsAdmin = payload;
    },
    setStatus(state, payload) {
      state.status = payload;
    },
    setUserId(state, payload) {
      state.userId = payload;
    },
    setUserEmail(state, payload) {
      state.userEmail = payload;
    },
    setUserName(state, payload) {
      state.userName = payload;
    },
    setUserAvatar(state, payload) {
      state.userAvatar = payload;
    },
    setUserBirthdate(state, payload) {
      state.userBirthdate = payload;
    },
    logoutUser(state) {
      state.userEmail = "";
      state.userId = "";
      state.user = "";
      state.userName = "";
    },
    setError(state, payload) {
      state.error = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setCheckedInStatus(state, payload) {
      state.userIsCheckedIn = payload;
    },
    setBookingDetails(state, payload) {
      state.bookingDetails = payload;
    },
    setEmailSentToCustomer(state, payload) {
      state.emailSentToCustomer = payload;
    },
    setEmailSentToAdmin(state, payload) {
      state.emailSentToAdmin = payload;
    },
    setBooked(state, payload) {
      state.booked = payload;
    },
  },
  actions: {
    async logoutAction({ commit }) {
      commit("setLoading", true);
      commit("logoutUser");
      commit("setLoading", false);
    },
    signUpAction({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("setStatus", "loading");
        firebase
          .auth()
          .createUserWithEmailAndPassword(payload.email, payload.password)
          .then((response) => {
            commit("setUser", response.user);
            commit("setUserEmail", response.user.email);
            commit("setStatus", "success");
            commit("setError", null);
            resolve(response);
          })
          .catch((error) => {
            commit("setStatus", "failure");
            commit("setError", error.message);
            reject(error);
          });
      });
    },
    signInAction({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("setStatus", "loading");
        firebase
          .auth()
          .signInWithEmailAndPassword(payload.email, payload.password)
          .then((response) => {
            commit("setUser", response.user);
            if (
              response.user.uid === "SGhnpN7xCLWduhi535Ul7HYjUAd2" ||
              response.user.uid === "AMzmiDbbe1V4nM1grnRugQRNo6z2"
            ) {
              commit("setAdmin", true);
            }
            commit("setStatus", "success");
            commit("setError", null);
            resolve(response);
          })
          .catch((error) => {
            commit("setStatus", "failure");
            commit("setError", error.message);
            reject(error);
          });
      });
    },
    signInWithProviderRedirect({ commit }) {
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope("https://www.googleapis.com/auth/contacts.readonly");
      firebase.auth().useDeviceLanguage();

      return new Promise((resolve, reject) => {
        commit("setStatus", "loading");
        firebase
          .auth()
          .signInWithPopup(provider)
          .then((response) => {
            commit("setUser", response.user.uid);
            // just hard checking for explicit admin UID for now, will follow up and do properly
            if (response.user.uid === "OsVat72OR9dfnN2t9iNAhQIpugA2") {
              commit("setAdmin", true);
            }
            commit("setUserEmail", response.user.email);
            commit("setStatus", "success");
            commit("setError", null);
            resolve(response);
          })
          .catch((error) => {
            commit("setStatus", "failure");
            commit("setError", error.message);
            reject(error);
          });
      });
    },
    signOutAction({ commit }) {
      firebase
        .auth()
        .signOut()
        .then(() => {
          commit("logoutUser");
          commit("setStatus", "success");
          commit("setError", null);
        })
        .catch((error) => {
          commit("setStatus", "failure");
          commit("setError", error.message);
        });
    },
    checkCurrentUserIsAdmin({ commit }) {
      firebase
        .auth()
        .currentUser.getIdTokenResult()
        .then((idTokenResult) => {
          // Confirm the user is an Admin.
          if (idTokenResult.claims.moderator) {
            commit("setAdmin", true);
          } else {
            commit("setAdmin", false);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /* eslint-disable no-unused-vars */
    bookAppointmentAction({ commit }, { slot, index, day, formData }) {
      try {
        const calEventRef = db.collection("calEvent").doc(day.date);
        db.runTransaction((transaction) => {
          // This code may get re-run multiple times if there are conflicts.
          return transaction.get(calEventRef).then((doc) => {
            if (!doc.data().slots) {
              transaction.set(calEventRef, {
                slots: [slot],
              });
            } else {
              slot.booked = true;
              slot.bookingData = formData;
              const slots = doc.data().slots;
              slots[index] = slot;
              transaction.set(calEventRef, {
                date: day.date,
                slots: slots,
              });
            }
          });
        });
        // commit("setBookingDetails", {
        //   slot,
        //   index,
        //   day,
        //   formData,
        // });
        console.log("Transaction was successful!");
        commit("setBooked", true);
      } catch (err) {
        console.log("Transaction failed: ", err);
      }
    },
    /* eslint-disable no-unused-vars */
    approveAppointmentAction({ getters }, { slot, index, day }) {
      try {
        const calEventRef = db.collection("calEvent").doc(day.date);
        db.runTransaction((transaction) => {
          // This code may get re-run multiple times if there are conflicts.
          return transaction.get(calEventRef).then((doc) => {
            if (!doc.data().slots) {
              transaction.set(calEventRef, {
                slots: [slot],
              });
            } else {
              slot.approved = true;
              const slots = doc.data().slots;
              slots[index] = slot;
              transaction.set(calEventRef, {
                date: day.date,
                slots: slots,
              });
            }
          });
        });
        console.log("Transaction was successful!");
      } catch (err) {
        console.log("Transaction failed: ", err);
      }
    },
    // Basically a reverse of the approval action above...
    unapproveSlotAction({ slot, index, day }) {
      try {
        const calEventRef = db.collection("calEvent").doc(day.date);
        db.runTransaction((transaction) => {
          return transaction.get(calEventRef).then((doc) => {
            console.log("slot", slot);
            console.log("slot status", slot.approved);
            if (slot.approved == false) {
              return;
            } else {
              slot.approved = false;
              const slots = doc.data().slots;
              slots[index] = slot;
              transaction.set(calEventRef, {
                date: day.date,
                slots: slots,
              });
              console.log("Slot status is now set to: ", slot.approved);
            }
          });
        });
        console.log("Transaction was successful!");
      } catch (err) {
        console.log("Transaction failed: ", err);
      }
    },
    checkBookingStatus({ getters }) {
      const data = getters.bookingDetails;
      if (data) {
        return true;
      } else {
        return false;
      }
    },
  },
  getters: {
    user(state) {
      return state.user;
    },
    userIsAdmin(state) {
      return state.userIsAdmin;
    },
    status(state) {
      return state.status;
    },
    loading(state) {
      return state.loading;
    },
    userId(state) {
      return state.userId;
    },
    userEmail(state) {
      return state.userEmail;
    },
    userAvatar(state) {
      return state.userAvatar;
    },
    userBirthdate(state) {
      return state.userBirthdate;
    },
    userName(state) {
      return state.userName;
    },
    userIsCheckedIn(state) {
      return state.userIsCheckedIn;
    },
    error(state) {
      return state.error;
    },
    bookingDetails(state) {
      return state.bookingDetails;
    },
    emailSentToCustomer(state) {
      return state.emailSentToCustomer;
    },
    emailSentToAdmin(state) {
      return state.emailSentToAdmin;
    },
    booked(state) {
      return state.booked;
    },
  },
  modules: {},
  plugins: [createPersistedState()],
});

export default store;
